import LegalMarkdown from "@/components/LegalMarkdown";
import LegalPageLayout from "@/components/LegalPageLayout";
import { TERMS_OF_USE_BODY } from "@/content/terms-of-use";

export default function TermsPage() {
  return (
    <LegalPageLayout title="Terms of Use" lastUpdated="May 26, 2026">
      <LegalMarkdown source={TERMS_OF_USE_BODY} />
    </LegalPageLayout>
  );
}
